module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/1-bfee08ac23e3eabc6cee68e0d5722727.jpg";